import dayjs from 'dayjs';
import { derived, writable } from 'svelte/store';
import { FOUR_DIGITS_YEAR_DATE_FORMAT } from './../../../../components/availability/availability-datepicker-config';

// Component container with
export const availabilityWindowWidth = writable(0);

// Parameter
export const isDateParametersValid = writable(false);

// Sitecore props
export const scContextItemId = writable('');
export const scContextItemIdQuery = derived(
  [scContextItemId],
  ($scContextItemId) => `contextItemId=${$scContextItemId}&`
);

export const scFormToken = writable('');
export const scFormTokenQuery = derived(
  [scFormToken],
  ($scFormToken) => `formToken=${$scFormToken}`
);

// Handling date
export const dateFrom = writable('');
export const dateTo = writable('');

/**
 * Get dates value
 * @author Dat Doan
 * @date 2021-08-25
 * @returns {Array.<date, date>}
 */
export const datesValue = derived(
  [dateFrom, dateTo],
  ([$dateFrom, $dateTo]) => {
    if ($dateFrom === '' && $dateTo === '') return [];
    if ($dateTo === '') return [dayjs($dateFrom).toDate()];;
    return [dayjs($dateFrom).toDate(), dayjs($dateTo).toDate()];
  }
);

/**
 * Dates value query string
 * @author Dat Doan
 * @date 2021-08-25
 * @returns {string}
 */
export const datesQuery = derived(
  [dateFrom, dateTo],
  ([$dateFrom, $dateTo]) => {
    return `dateFrom=${dayjs($dateFrom).format(
      FOUR_DIGITS_YEAR_DATE_FORMAT
    )}&dateTo=${dayjs($dateTo).format(FOUR_DIGITS_YEAR_DATE_FORMAT)}&`;
  }
);

// Handling guest
export const adultsValue = writable(1);
export const childrenValue = writable(0);
export const infantsValue = writable(0);

/**
 * Get number of guest
 * @author Dat Doan
 * @date 2021-08-25
 * @returns {number}
 */
export const numberOfGuest = derived(
  [adultsValue, childrenValue, infantsValue],
  ([$adults, $children, $infants]) => $adults + $children + $infants
);

/**
 * Guest value query string
 * @author Dat Doan
 * @date 2021-08-25
 * @returns {string}
 */
export const guestsQuery = derived(
  [adultsValue, childrenValue, infantsValue],
  ([$adultsValue, $childrenValue, $infantsValue]) =>
    `adults=${$adultsValue}&children=${$childrenValue}&infants=${$infantsValue}`
);

// Multiple button
export const isTriggerCheckAvailabilityState = writable(0);

// Skeleton skin
export const isLoadingSkeleton = writable(true);
